import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function renewGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const firstLoad = !from.matched?.length
  const fromAuth = ['login', 'register'].includes(from?.name || '')
  const canRenew = store.getters['subscription/canRenew'] && !store.getters['subscription/isRecurringSubscriptionPayment']
  const forRenew = to.params.id === 'renew'

  if ((firstLoad || fromAuth) && forRenew && !canRenew) return next({ name: 'billing:plans' })

  return next()
}

export default renewGuard
